import { ApplicationTypes } from "actions/types";
import createReducer from "utils/createReducer";

import { fromJS } from "immutable";

export const defaultValue = fromJS({
  "--main-bg-color": "Brown",
  "--font-color-highlight": "#FFCC00",
  "--filter-color-highlight": "#FF2F31",
  "--game-nav-color": "#FFCC00",
  "--game-nav-color-hover": "#FFCC00",
  "--game-nav-color-selected": "#FFCC00",
});

export const theme = createReducer(defaultValue, {
  [ApplicationTypes.SET_THEME](state, { payload }) {
    if (!payload || payload === "") {
      return defaultValue;
    }

    return fromJS(payload);
  },
});
